import { XStack, Text } from "tamagui";
import { colors } from "@styles/colors";
import { useSkinV2Page, v2 } from "@screen/Home/pages/GasShop/skin";

interface SectionLabelProps {
  title: string;
  right?: React.ReactNode;
  /**
   * "light"：這個區塊標題落在頁面頂端的藍色帶上（如帳號頁的第一個區塊），改用白字。
   * 灰字（v2.label）壓在藍底上對比不足，看起來會髒。用詞與 SkinTabs 的 tone 一致。
   */
  tone?: "dark" | "light";
}

/** 區塊小標題：左側灰字標題 + 右側可選動作 */
export default function SectionLabel({ title, right, tone = "dark" }: SectionLabelProps) {
  // V2 與瓦斯訂購／訂單頁的區塊標題同款（13.5px、v2.label、明寫行高避免上下多出隱形空間）
  const skinV2 = useSkinV2Page();
  return (
    <XStack jc="space-between" ai="center" mb={skinV2 ? 6 : "$2"} pl={skinV2 ? 2 : "$1"}>
      <Text
        fontSize={skinV2 ? 13.5 : 12}
        lineHeight={skinV2 ? 16 : undefined}
        fontWeight={skinV2 ? "700" : "600"}
        color={tone === "light" ? "rgba(255,255,255,0.9)" : skinV2 ? v2.label : colors.sub}>
        {title}
      </Text>
      {right}
    </XStack>
  );
}
